import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

import sleepAndRestHeroBgGradients from './data/sleepAndRestHeroBgGradients';
import sleepAndRestHeroGradients from './data/sleepAndRestHeroGradients';

const SleepAndRestHero = () => {
  return (
    <section data-cy="sleep-and-rest-hero">
      <RadialGradientBG
        gradients={sleepAndRestHeroBgGradients}
        background={null}
      >
        <LandingPageHero
          backgroundProps={{
            color: 'slate-300',
            gradients: sleepAndRestHeroGradients,
          }}
          copy="sleep_and_rest_hero_description"
          eyebrow="sleep_and_rest_hero_eyebrow"
          images={[
            {
              localizedAlt: 'sleep_and_rest_hero_or4_two_img_alt',
              src: '/blue-sky/sleep-and-rest/sleep-and-rest-hero-or4-two',
            },
            {
              localizedAlt: 'sleep_and_rest_hero_or4_one_img_alt',
              src: '/blue-sky/sleep-and-rest/sleep-and-rest-hero-or4-one',
            },
          ]}
          textColor="text-sandstone-200"
          title="sleep_and_rest_hero_title"
        />
      </RadialGradientBG>
    </section>
  );
};

export default SleepAndRestHero;
